import color from 'atoms/colors/colors';
import shadow from 'atoms/shadows/shadows';
import { fontSize, fontWeight, lineHeight } from 'atoms/typography/typography';

const helperTextStyles = {
  fontSize: fontSize.textXs,
  marginLeft: 0,
  letterSpacing: '0.3px',
};

const inputRootStyles = {
  minHeight: 48,
  borderRadius: 8,
};

export const lightTextField = {
  MuiFormHelperText: {
    styleOverrides: {
      root: {
        color: color.gray[400],
        ...helperTextStyles,
      },
    },
  },
  MuiInputAdornment: {
    styleOverrides: {
      root: {
        color: color.gray[400],
      },
    },
  },
  MuiInputBase: {
    styleOverrides: {
      root: {
        fontSize: fontSize.textSm,
        lineHeight: lineHeight.textSm,
        color: color.gray[900],
        border: `1px solid ${color.gray[200]}`,
        boxShadow: shadow.xs,
        '&.Styled-MuiTextfield': {
          padding: '8px 12px !important',
        },
        '&.Mui-focused': {
          borderColor: color.green[300],
          boxShadow: `0px 1px 2px rgba(35, 35, 37, 0.05), 0px 0px 2px 2px ${color.green[50]}`,
        },
        '&.Mui-error': {
          borderColor: color.sunset[200],
          boxShadow: `0px 1px 2px rgba(35, 35, 37, 0.05), 0px 0px 2px 2px ${color.sunset[25]}`,
          '.MuiInputAdornment-root': {
            color: color.sunset[400],
          },
        },
        ...inputRootStyles,
      },
    },
  },
  MuiInputLabel: {
    styleOverrides: {
      root: {
        transform: 'none',
        fontWeight: fontWeight.bold,
        fontSize: fontSize.textXs,
        color: color.gray[700],
        '&.Mui-focused': {
          color: color.gray[700],
        },
      },
    },
  },
};

export const darkTextField = {
  MuiFormHelperText: {
    styleOverrides: {
      root: {
        color: color.gray[200],
        ...helperTextStyles,
      },
    },
  },
  MuiInputAdornment: {
    styleOverrides: {
      root: {
        color: color.gray[400],
      },
    },
  },
  MuiInputBase: {
    styleOverrides: {
      root: {
        fontSize: fontSize.textSm,
        lineHeight: lineHeight.textSm,
        color: color.gray[900],
        border: `1px solid ${color.gray[200]}`,
        '&.Styled-MuiTextfield': {
          padding: '8px 12px !important',
        },
        '&.Mui-focused': {
          borderColor: color.green[300],
          boxShadow: `0px 1px 2px rgba(35, 35, 37, 0.05), 0px 0px 2px 2px ${color.green[50]}`,
        },
        '&.Mui-error': {
          borderColor: color.green[300],
          boxShadow: `0px 1px 2px rgba(35, 35, 37, 0.05), 0px 0px 2px 2px ${color.green[50]}`,
          '.MuiInputAdornment-root': {
            color: color.green[600],
          },
        },
        '&&': {
          backgroundColor: color.common.white,
        },
        ...inputRootStyles,
      },
    },
  },
  MuiInputLabel: {
    styleOverrides: {
      root: {
        fontWeight: fontWeight.bold,
        color: color.gray[200],
        '&.Mui-focused': {
          color: color.gray[200],
        },
      },
    },
  },
};
